export function preloadAllImages() {
  const imageList = [
    // ========== 首页背景图 ==========
    require("@/assets/imgs/promotionGift/homeBg.png"),
    require("@/assets/imgs/promotionGift/homeBg2.png"),

    // ========== 报名状态按钮（5 个状态）==========
    require("@/assets/imgs/promotionGift/btnStatus1.png"),
    require("@/assets/imgs/promotionGift/btnStatus2.png"),
    require("@/assets/imgs/promotionGift/btnStatus3.png"),
    require("@/assets/imgs/promotionGift/btnStatus4.png"),
    require("@/assets/imgs/promotionGift/btnStatus5.png"),
    require("@/assets/imgs/promotionGift/btnStatus6.png"),
    require("@/assets/imgs/promotionGift/btnStatus7.png"),
    require("@/assets/imgs/promotionGift/btnStatus8.png"),
    require("@/assets/imgs/promotionGift/btnStatus9.png"),
    require("@/assets/imgs/promotionGift/btnStatus10.png"),
    require("@/assets/imgs/promotionGift/btnStatus11.png"),
    require("@/assets/imgs/promotionGift/btnStatus12.png"),

    // ========== Tab 切换 ==========
    require("@/assets/imgs/promotionGift/tabItem.png"),
    require("@/assets/imgs/promotionGift/tabItemActive.png"),

    // ========== 奖励列表背景（6 档）==========
    require("@/assets/imgs/promotionGift/第1档.png"),
    require("@/assets/imgs/promotionGift/第2档.png"),
    require("@/assets/imgs/promotionGift/第3档.png"),
    require("@/assets/imgs/promotionGift/第4档.png"),
    require("@/assets/imgs/promotionGift/第5档.png"),
    require("@/assets/imgs/promotionGift/第6档.png"),

    // ========== 提示弹框 ==========
    require("@/assets/imgs/promotionGift/toastBg.png"),
    require("@/assets/imgs/promotionGift/toastBtn.png"),

    // ========== 记录弹框 ==========
    require("@/assets/imgs/promotionGift/recordBg.png"),

    // ========== 规则弹框 ==========
    // 如果有背景图，添加到这里
    // require('@/assets/imgs/promotionGift/ruleBg.png'),

    // ========== 领取弹框 ==========
    require("@/assets/imgs/promotionGift/rewardBg.png"),
    require("@/assets/imgs/promotionGift/rewardBtn.png"),
    require("@/assets/imgs/promotionGift/rewardCheck.png"),

    // ========== 详情页 ==========
    require("@/assets/imgs/promotionGift/detailLogo.png"),
    require("@/assets/imgs/promotionGift/detailWx.png"),
    require("@/assets/imgs/promotionGift/detailJd.png"),
    require("@/assets/imgs/promotionGift/detailJf.png"),
    require("@/assets/imgs/promotionGift/detailHf.png"),
  ];

  // 预加载所有图片
  const promises = imageList.map((src) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        // console.log('✅ 图片加载成功:', src.split('/').pop())
        resolve(src);
      };
      img.onerror = () => {
        // console.warn('❌ 图片加载失败:', src.split('/').pop())
        resolve(src); // 失败也继续，避免阻塞
      };
      img.src = src;
    });
  });

  return Promise.all(promises);
}

export function preloadJhPageImages() {
  const imageList = [
    // 聚合背景图
    require("@/assets/imgs/promotionGift/jhPageBg.png"),

    // 聚合页按钮背景图及前缀
    require("@/assets/imgs/promotionGift/jhPageBtn1.png"),
    require("@/assets/imgs/promotionGift/jhPageBtn2.png"),
    require("@/assets/imgs/promotionGift/jhPageBtn3.png"),
    require("@/assets/imgs/promotionGift/jhPageJimeng1.png"),
    require("@/assets/imgs/promotionGift/jhPageJimeng2.png"),
    require("@/assets/imgs/promotionGift/jhPageJimeng3.png"),
    require("@/assets/imgs/promotionGift/jhPageShare.png"),
    require("@/assets/imgs/xibReturnGift/rule_close.png"),
    require("@/assets/imgs/promotionGift/jhPageBg.png"),
  ];

  // 预加载所有图片
  const promises = imageList.map((src) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        // console.log('✅ 图片加载成功:', src.split('/').pop())
        resolve(src);
      };
      img.onerror = () => {
        // console.warn('❌ 图片加载失败:', src.split('/').pop())
        resolve(src); // 失败也继续，避免阻塞
      };
      img.src = src;
    });
  });

  return Promise.all(promises);
}
